import _ from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';
import { addCampaignTypePropertyForFilter } from '../util/update-campaign-type-property-for-filter';
import { updateDeliveryStatusPropertyForFilter } from '../util/update-delivery-status-property-for-filter';

/* eslint-disable no-param-reassign */

export class AdGroupCriterionSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);

    // update schema to remove labels property
    updatedSchema.properties = _.omit(updatedSchema.properties, 'Labels');

    const deliveryStatusFilters = [
      'InvalidFinancialStatusOther',
      'CampaignSuspended',
      'CampaignBudgetPaused',
      'CampaignUserPaused',
      'Eligible',
      'AdGroupExpired',
      'AdGroupDraft',
      'AdGroupUserPaused',
      'AdGroupPrivacyPending',
      'AdGroupTargetingTooNarrow',
      'AdGroupCriterionExcluded',
    ];

    if (this.Permissions && this.Permissions.dynamic && this.Permissions.dynamic.CampaignLifetimeBudget) {
      deliveryStatusFilters.push('CampaignExpired');
    }

    updateDeliveryStatusPropertyForFilter(updatedSchema, deliveryStatusFilters);

    // make campaignstatus and adgroupproperty not show in filter drop down
    const campaignStatusProperty = updatedSchema.properties.CampaignStatus;
    if (campaignStatusProperty) {
      campaignStatusProperty.filterable = false;
    }

    const adgroupStatusProperty = updatedSchema.properties.AdGroupStatus;
    if (adgroupStatusProperty) {
      adgroupStatusProperty.filterable = false;
    }

    if (this.Permissions.IsPersonalizedOffersEnabled) {
      updatedSchema.properties.CriterionCashback = {
        filterable: true,
        type: 'number',
        minimum: 0,
        maximum: 50,
        required: true,
      };
    }

    // only add campaign type filter at account scope
    // eslint-disable-next-line max-len
    if (this.isForVNext) {
      const campaignTypeNotSupported = ["Enum.CampaignType'Hotel'", "Enum.CampaignType'PerformanceMax'", "Enum.CampaignType'LinkedIn'"];
      addCampaignTypePropertyForFilter({
        entitySchema: updatedSchema, permissions: this.Permissions,
      });
      updatedSchema.properties.CampaignType.enum =
      _.difference(updatedSchema.properties.CampaignType.enum, campaignTypeNotSupported);
    }
    return updatedSchema;
  }
}
